document.addEventListener("DOMContentLoaded", function () {
  let popupConfirmButtons = document.querySelectorAll('.popup-modal__buttons button[type="button"]');
  let overlay = document.getElementById("global-overlay");

  function closePopover() {
    document.body.classList.remove("open-popover-fixed");
    if (overlay) overlay.classList.remove("active");
  }

  document.querySelectorAll('[popovertargetaction="show"]').forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      document.body.classList.add("open-popover-fixed");
      if (overlay) overlay.classList.add("active");
    });
  });

  document.querySelectorAll('[popovertargetaction="hide"]').forEach(function (trigger) {
    trigger.addEventListener("click", closePopover);
  });

  if (overlay) {
    overlay.addEventListener("click", closePopover);
  }

  document.addEventListener('click', function (e) {
    const popoverButton = e.target.closest('.popup-confirm');
    if (popoverButton) {
      const productFormSubmit = document.querySelector('.cart-submit-button');
      let targetForm = popoverButton.closest('form');
      if (productFormSubmit && targetForm) {
        overlay.classList.remove("active");
        targetForm.requestSubmit();
        closePopover();
        if (window.location.href.includes('/products/')) {
          productFormSubmit.click();
        }
      } else {
        console.error('Unable to complete popover form handling.');
      }
    }
  });

  popupConfirmButtons.forEach(function (button) {
    button.addEventListener('click', function (e) {
      let popoverId = button.closest('.product-popover-wrapper').id;

      let closeButton = button.closest('.product-popover-wrapper').querySelector(`[popovertarget="${popoverId}"]`);
      if (closeButton) {
        closeButton.setAttribute('popovertargetaction', 'hide');

        closeButton.click();
      }
    });
  });
});
